import DealerKit from "../../js/api";
let accounts = undefined;
async function getLedgerAccounts() {
    if (!accounts) {
        await DealerKit.accounting.getLedgerAccounts().then(response => {
            accounts = response.data.data;
        });
    }
    return accounts;
}
export { getLedgerAccounts };
